import * as React from 'react';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { BoardExportHOC } from '../../hocs/BoardExportHOC/BoardExportHOC';

export function TabExportContext () {
    const { boardId } = React.useContext(AsidePanelContext);

    return <BoardExportHOC boardId={boardId}/>;
}
